const React = require("react");
const T = React.PropTypes;

const baseStyle = {
    padding: "6px 8px 5px 8px",
    color: "#fff",
    borderRadius: "50%",
    textShadow: "0 0 5px #a00"
};

const RemoveButton = React.createClass({
    propTypes: {
        onClick: T.func
    },
    render() {
        const style = Object.assign({}, this.props.style, baseStyle);

        return (<button className="btn btn-danger" style={style} onClick={this.props.onClick}>
            <span className="glyphicon glyphicon-remove"></span>
        </button>)
    }
});

module.exports = RemoveButton;


// WEBPACK FOOTER //
// ./src/components/RemoveButton.jsx